import { GetStaticPathsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next';
import React from 'react';

import SEO from '../../components/organisms/seo';
import { SiteFooter } from '../../components/organisms/site-footer';
import { SiteNav } from '../../components/organisms/site-nav';
import { PageTemplate } from '../../components/templates/page-template';
import { fetchPolicy } from '../../utils/policies';

interface Props {
  content: string;
  title?: string;
}

const PolicyPage: React.FC<Props> = (props) => {
  let { content, title } = props;

  return (
    <PageTemplate>
      <SEO title={title} description={title} />

      <SiteNav showCart={false} shopLinkActive />

      <div className="mx-auto my-8 max-w-7xl px-6">
        <div className="md-content mb-4" dangerouslySetInnerHTML={{ __html: content }} />
      </div>

      <SiteFooter />
    </PageTemplate>
  );
};

export async function getStaticProps(context: GetStaticPropsContext): Promise<GetStaticPropsResult<Props>> {
  try {
    let policyName = context.params?.policy;
    let cleanedPolicyName = Array.isArray(policyName) ? policyName.join('-') : policyName;
    let policy = await fetchPolicy(cleanedPolicyName ?? '-', context.locale ?? 'en');

    if (!policy) {
      throw new Error(`Policy ${cleanedPolicyName} not found`);
    }

    return {
      props: {
        content: policy.html,
        title: policy?.data?.title || 'Policy',
      },
    };
  } catch (err) {
    console.error(err);

    return {
      notFound: true,
    };
  }
}

export function getStaticPaths(): GetStaticPathsResult {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export default PolicyPage;
